module.exports = __webpack_public_path__ + "static/img/document_poster.a5bd190.png";